import { RouteMetadata } from './types';

export const connectionsMetadata: RouteMetadata[] = [
    {
        pattern: '/agents/:agentId/connections',
        section: 'connections',
        view: 'list',
        descriptionTemplate: 'User is viewing the connections list',
        capabilities: [
            'View all OAuth connections',
            'Create new connections to third-party services',
            'Update connection settings',
            'Remove connections',
            'Test connection status',
            'Refresh access tokens',
        ],
        hints: [
            'Connections enable integration with external services',
            'OAuth connections require authorization from the service',
            'Connections can be used in workflows to access APIs',
            'Connection status shows if they are active or expired',
            'Common connections include Google, Meta, Slack, and custom OAuth providers',
        ],
    },
];
